import Login from '@/assets/js/apiObj/account'
import Species from '@/assets/js/apiObj/Species'
import Address from '@/assets/js/apiObj/Address'
import ReacueReason from '@/assets/js/apiObj/RecueReason';
import AnimalAttackType from '@/assets/js/apiObj/AnimalAttackType';
import Feeding from '@/assets/js/apiObj/Feeding';
import Intake from '@/assets/js/apiObj/Intake';

class SampleData {
    //物件建立時產生
    constructor(){
        this.login = new Login();
        this.species = new Species();
        this.address = new Address();
        this.reacueReason = new ReacueReason();
        this.animalAttackType = new AnimalAttackType();
        this.feeding = new Feeding();
        this.intake = new Intake();

        //bill建立的測試資料
        this.species_list = [
            { species_id:1,species_name:'哺乳類' },
            { species_id:2,species_name:'鳥類-鷹隼' },
            { species_id:3,species_name:'鳥類-鴞型目' },
            { species_id:4,species_name:'鳥類-其他' },
            { species_id:5,species_name:'兩爬類' },
        ]

        this.specie_list = [
            {
                species_id:1,
                specie:[
                    { specie_id:1,specie_name:'穿山甲' },
                    { specie_id:2,specie_name:'台灣獼猴' },
                    { specie_id:3,specie_name:'白鼻心' }
                ]
            },{
                species_id:2,
                specie:[
                    { specie_id:1,specie_name:'東方蜂鷹' },
                    { specie_id:2,specie_name:'黑冠鵑隼' },
                    { specie_id:3,specie_name:'禿鷲' }
                ]
            },{
                species_id:3,
                specie:[
                    { specie_id:1,specie_name:'草鴞' },
                    { specie_id:2,specie_name:'黃嘴角鴞' },
                    { specie_id:3,specie_name:'領角鴞' }
                ]
            },{
                species_id:4,
                specie:[
                    { specie_id:1,specie_name:'灰背鷗' },
                    { specie_id:2,specie_name:'北極鷗' },
                    { specie_id:3,specie_name:'玄燕鷗' }
                ]
            },{
                species_id:5,
                specie:[
                    { specie_id:1,specie_name:'中華眼鏡蛇' },
                    { specie_id:2,specie_name:'食蛇龜' },
                    { specie_id:3,specie_name:'大頭蛇' }
                ]
            }
        ]

        this.locationList =[
            {id:1,name:'野放訓練室'},
            {id:2,name:'戶外籠舍'},
        ]

        this.ans = [
            { 
                ans_id:1,
                main_item_id:1,
                sub_item_id:1,
                col_id:1,
                ans_data:''
            },{ 
                ans_id:2,
                main_item_id:1,
                sub_item_id:1,
                col_id:2,
                ans_data:''
            }
        ]

        this.testTypeFormData = {
            form_id:null,
            form_name:'測試表格',
            form_species:[
                {
                    specie_id:1,
                    specie_name:'台灣獼猴'
                },{
                    specie_id:2,
                    specie_name:'狒狒'
                }
            ],
            forms:[
                {
                    main_item_id:1,
                    main_item_name:'個體辨識',
                    layoutType:0,
                    sub_items:[
                        {   
                            sub_item_id:1,
                            sub_item_name:'個體辨識/晶片',
                            layoutType:2,
                            cols:[
                                {
                                    col_id:1,
                                    col_type:0,
                                    col_name:'晶片ID',

                                },{
                                    col_type:0,
                                    col_name:'位置'
                                },{
                                    col_type:0,
                                    col_name:'或其他人為標記'
                                },{
                                    col_type:0,
                                    col_name:'新植入晶片ID'
                                },
                                
                            ]
                        },{
                            sub_item_name:'個體辨識/外觀',
                            layoutType:2,
                            cols:[
                                {
                                    col_type:3,
                                    col_name:'性別',
                                    col_option:['雄','雌']
                                },{
                                    col_type:3,
                                    col_name:'年齡',
                                    col_option:['幼體','亞成體','成體']
                                },{
                                    col_type:0,
                                    col_name:'毛髮顏色'
                                },{
                                    col_type:3,
                                    col_name:'換毛',
                                    col_option:['Y','N']
                                },
                                
                            ]
                        },{
                            sub_item_name:'個體辨識/耳標',
                            layoutType:2,
                            cols:[
                                {
                                    col_type:3,
                                    col_name:'耳標',
                                    col_option:['Y','N']
                                },{
                                    col_type:0,
                                    col_name:'左耳',
                                },{
                                    col_type:0,
                                    col_name:'右耳'
                                },{
                                    col_type:0,
                                    col_name:'顏色',
                                },
                            ]
                        },{
                            sub_item_name:'外觀特徵(如疤痕)',
                            layoutType:2,
                            cols:[
                                {
                                    col_type:0,
                                    col_name:'特徵說明'
                                },{
                                    col_type:2,
                                    col_name:'下顎白斑(長)',
                                    col_unit:'CM'
                                },{
                                    col_type:2,
                                    col_name:'下顎白斑(寬)',
                                    col_unit:'CM'
                                }
                                
                            ]
                        },{
                            sub_item_name:'胸前白斑(cm)',
                            layoutType:2,
                            cols:[
                                {
                                    col_type:2,
                                    col_name:'A',
                                    col_unit:'CM'
                                },{
                                    col_type:2,
                                    col_name:'B',
                                    col_unit:'CM'
                                },{
                                    col_type:2,
                                    col_name:'C',
                                    col_unit:'CM'
                                },{
                                    col_type:2,
                                    col_name:'D',
                                    col_unit:'CM'
                                },{
                                    col_type:0,
                                    col_name:'顏色',
                                }
                                
                            ]
                        },{
                            sub_item_name:'胸前V斑(示意)',
                            layoutType:2,
                            cols:[
                                {
                                    col_type:6,
                                    col_img:'xxxx.png',
                                    col_img_url:'https://dev.matranx.com.tw/ux/wildoneHis/images/8_2_1-%E5%BD%A2%E8%B3%AA%E6%B8%AC%E9%87%8F%E7%AE%A1%E7%90%86-%E6%96%B0%E5%A2%9E-%E5%A1%AB%E5%AF%AB%E8%A9%95%E4%BC%B0%E8%A1%A8/u27875.jpg'
                                }
                            ]
                        }
                    ]
                },{
                    main_item_name:'腳掌',
                    layoutType:0,
                    sub_items:[
                        {
                            sub_item_name:'前腳',
                            layoutType:1,
                            cols:[
                                {
                                    col_type:1,
                                    col_name:'尾長',
                                    col_unit:'CM，尾巴根部至末端'
                                },{
                                    col_type:3,
                                    col_name:'換毛',
                                    col_option:['YES','NO']
                                },{
                                    col_type:4,
                                    col_name:'照片A',
                                    col_option:['正面開口閉','側面開口閉']
                                },{
                                    col_type:5,
                                    col_name:'照片B',
                                    col_option:['正面開口閉','側面開口閉']
                                },{
                                    col_type:6,
                                    col_img:'OOXX.png',
                                    col_img_url:'https://dev.matranx.com.tw/ux/wildoneHis/images/8_2_1-%E5%BD%A2%E8%B3%AA%E6%B8%AC%E9%87%8F%E7%AE%A1%E7%90%86-%E6%96%B0%E5%A2%9E-%E5%A1%AB%E5%AF%AB%E8%A9%95%E4%BC%B0%E8%A1%A8/u27904.jpg'
                                },
                            ]
                        },{
                            sub_item_name:'後腳',
                            layoutType:1,
                            cols:[{
                                col_type:0,
                                col_name:'晶片ID'
                            },{
                                col_type:1,
                                col_name:'頭長',
                                col_unit:'CM，枕骨大孔至'
                            },]
                        }
                    ]
                }
            ]
        }

        this.testWaitTestList = [
            {
                test_id: 2,
                test_type: 1,  // 病毒/抗體
                test_unit: '臺大動物法醫',
                healthRecord_no: 'H0240810003',
                species_name: '大熊貓',
                animal_name: '小熊',
                booking_test_date: ''
            },
            {
                test_id: 3,
                test_type: 2,  // 細菌等微生物
                test_unit: '周洵老師',
                healthRecord_no: 'H0240810004',
                species_name: '白犀牛',
                animal_name: '壯壯',
                booking_test_date: ''
            },
            {
                test_id: 4,
                test_type: 3,  // 傷口口水鑑定
                test_unit: '芮弗士',
                healthRecord_no: 'H0240810005',
                species_name: '黑猩猩',
                animal_name: '阿黑',
                booking_test_date: '2024-08-25'
            },
            {
                test_id: 5,
                test_type: 4,  // 病理解剖
                test_unit: '獸醫所',
                healthRecord_no: 'H0240810006',
                species_name: '長頸鹿',
                animal_name: '高高',
                booking_test_date: ''
            },
            {
                test_id: 6,
                test_type: 5,  // 毒物/重金屬
                test_unit: '賴奕德博士',
                healthRecord_no: 'H0240810007',
                species_name: '紅鶴',
                animal_name: '飛飛',
                booking_test_date: '2024-09-01'
            },
            {
                test_id: 7,
                test_type: 6,  // 內外寄生蟲
                test_unit: '大安聯合',
                healthRecord_no: 'H0240810008',
                species_name: '亞洲象',
                animal_name: '大象',
                booking_test_date: ''
            },
            {
                test_id: 8,
                test_type: 7,  // 性別/物種鑑定
                test_unit: '中興微生物',
                healthRecord_no: 'H0240810009',
                species_name: '馬來貘',
                animal_name: '貘貘',
                booking_test_date: '2024-09-07'
            },
            {
                test_id: 9,
                test_type: 8,  // 荷爾蒙檢測
                test_unit: '屏科鳥店',
                healthRecord_no: 'H0240810010',
                species_name: '海豚',
                animal_name: '小海',
                booking_test_date: ''
            },
            {
                test_id: 10,
                test_type: 9,  // 其他研究(請備註)
                test_unit: '合作_中興黴漿菌',
                healthRecord_no: 'H0240810011',
                species_name: '老虎',
                animal_name: '威威',
                booking_test_date: '2024-09-14'
            },
            {
                test_id: 11,
                test_type: 1,  // 病毒/抗體
                test_unit: '臺大公衛所',
                healthRecord_no: 'H0240810012',
                species_name: '豹貓',
                animal_name: '小豹',
                booking_test_date: '2024-09-18'
            }
        ]

        this.defaultApplyData = {
            test_type:0,
            test_unit:0,
            note:'',
            applyFile:null,
            applyFile_name:'',
            reportFile:null,
            reportFile_name:'',
            reportFile_date:null,
            uploadReport_url:'',
            testTargets:[]
        }

        this.ApplyDatas = [
            {
                test_type:2,
                test_unit:2,
                note:'',
                applyFile:null,
                applyFile_url:'https://docs.google.com/spreadsheets/d/1XPEmeLmwIVoHreBU0atCqBadRW3Fq8IPTHFvZcqQT-Q/edit?usp=drive_link',
                applyFile_name:'2024-08-10檢驗清單.xlsx',
                reportFile:null,
                reportFile_name:'',
                reportFile_url:'',
                reportFile_date:null,
                uploadReport_url:'https://localhost:8080/testReport/1',
                testTargets:[1,2],
                applyTestList:[
                    {
                        test_id: 1,
                        test_type: 2,  // 固定唯一
                        specimenTypes: 1,  // 由0~7亂數產生
                        inspectionUnits: 2,  // 固定唯一
                        healthRecord_no: 'H0240810001',
                        specie_name: '台灣獼猴',
                        animal_name: '小小',
                        apply_data: '2024/08/25'
                    },
                    {
                        test_id: 2,
                        test_type: 2,  // 固定唯一
                        specimenTypes: 3,  // 由0~7亂數產生
                        inspectionUnits: 2,  // 固定唯一
                        healthRecord_no: 'H0240810002',
                        specie_name: '石虎',
                        animal_name: '虎虎',
                        apply_data: '2024/08/25'
                    },
                ]
            },{
                test_type:3,
                test_unit:3,
                note:'',
                applyFile:null,
                applyFile_url:'https://docs.google.com/spreadsheets/d/1XPEmeLmwIVoHreBU0atCqBadRW3Fq8IPTHFvZcqQT-Q/edit?usp=drive_link',
                applyFile_name:'2024-08-10檢驗清單.xlsx',
                reportFile:null,
                reportFile_name:'2024-08-30 檢驗報告.xlsx',
                reportFile_url:'https://docs.google.com/spreadsheets/d/1XPEmeLmwIVoHreBU0atCqBadRW3Fq8IPTHFvZcqQT-Q/edit?usp=drive_link',
                reportFile_date:'2024-08-30',
                uploadReport_url:'https://localhost:8080/testReport/2',
                testTargets:[5,6],
                applyTestList:[
                    {
                        test_id: 5,
                        test_type: 3,  // 固定唯一
                        specimenTypes: 4,  // 由0~7亂數產生
                        inspectionUnits: 3,  // 固定唯一
                        healthRecord_no: 'H0240810005',
                        specie_name: '紅毛猩猩',
                        animal_name: '紅紅',
                        apply_data: '2024/08/25'
                    },
                    {
                        test_id: 6,
                        test_type: 3,  // 固定唯一
                        specimenTypes: 5,  // 由0~7亂數產生
                        inspectionUnits: 3,  // 固定唯一
                        healthRecord_no: 'H0240810006',
                        specie_name: '白鼻心',
                        animal_name: '小白',
                        apply_data: '2024/08/25'
                    },
                ]
            }
        ]

        this.roleList = [
            {
                role_id:1,
                role_name:'獸醫主任',
                role_group:'獸醫師',
                create_date:'204/05/21'
            },{
                role_id:2,
                role_name:'獸醫師',
                role_group:'獸醫師',
                create_date:'204/05/21'
            },{
                role_id:3,
                role_name:'照養組長',
                role_group:'照養組',
                create_date:'204/05/21'
            },{
                role_id:4,
                role_name:'照養員',
                role_group:'照養組',
                create_date:'204/05/21'
            }
        ]

        this.accountList = [
            {
                account_id: 1,
                account: 'john.doe@example.com',
                account_no: 'A001',
                name: 'John Doe',
                role_id: 1,  // 獸醫主任
                create_date: '2024/08/01',
                status: 0  // 啟用
            },
            {
                account_id: 2,
                account: 'jane.smith@example.com',
                account_no: 'A002',
                name: 'Jane Smith',
                role_id: 2,  // 獸醫師
                create_date: '2024/08/02',
                status: 1  // 停權
            },
            {
                account_id: 3,
                account: 'robert.brown@example.com',
                account_no: 'A003',
                name: 'Robert Brown',
                role_id: 3,  // 照養組長
                create_date: '2024/08/03',
                status: 0  // 啟用
            },
            {
                account_id: 4,
                account: 'lucy.wang@example.com',
                account_no: 'A004',
                name: 'Lucy Wang',
                role_id: 4,  // 照養員
                create_date: '2024/08/04',
                status: 0  // 啟用
            },
            {
                account_id: 5,
                account: 'david.lee@example.com',
                account_no: 'A005',
                name: 'David Lee',
                role_id: 2,  // 獸醫師
                create_date: '2024/08/05',
                status: 1  // 停權
            },
            {
                account_id: 6,
                account: 'emily.taylor@example.com',
                account_no: 'A006',
                name: 'Emily Taylor',
                role_id: 3,  // 照養組長
                create_date: '2024/08/06',
                status: 0  // 啟用
            },
            {
                account_id: 7,
                account: 'michael.jones@example.com',
                account_no: 'A007',
                name: 'Michael Jones',
                role_id: 4,  // 照養員
                create_date: '2024/08/07',
                status: 0  // 啟用
            },
            {
                account_id: 8,
                account: 'susan.martin@example.com',
                account_no: 'A008',
                name: 'Susan Martin',
                role_id: 1,  // 獸醫主任
                create_date: '2024/08/08',
                status: 0  // 啟用
            },
            {
                account_id: 9,
                account: 'kevin.moore@example.com',
                account_no: 'A009',
                name: 'Kevin Moore',
                role_id: 2,  // 獸醫師
                create_date: '2024/08/09',
                status: 1  // 停權
            },
            {
                account_id: 10,
                account: 'anna.hall@example.com',
                account_no: 'A010',
                name: 'Anna Hall',
                role_id: 3,  // 照養組長
                create_date: '2024/08/10',
                status: 0  // 啟用
            },
            {
                account_id: 11,
                account: 'jack.wilson@example.com',
                account_no: 'A011',
                name: 'Jack Wilson',
                role_id: 4,  // 照養員
                create_date: '2024/08/11',
                status: 0  // 啟用
            },
            {
                account_id: 12,
                account: 'linda.clark@example.com',
                account_no: 'A012',
                name: 'Linda Clark',
                role_id: 2,  // 獸醫師
                create_date: '2024/08/12',
                status: 1  // 停權
            },
            {
                account_id: 13,
                account: 'charles.lewis@example.com',
                account_no: 'A013',
                name: 'Charles Lewis',
                role_id: 3,  // 照養組長
                create_date: '2024/08/13',
                status: 0  // 啟用
            },
            {
                account_id: 14,
                account: 'nancy.walker@example.com',
                account_no: 'A014',
                name: 'Nancy Walker',
                role_id: 4,  // 照養員
                create_date: '2024/08/14',
                status: 0  // 啟用
            },
            {
                account_id: 15,
                account: 'george.robinson@example.com',
                account_no: 'A015',
                name: 'George Robinson',
                role_id: 1,  // 獸醫主任
                create_date: '2024/08/15',
                status: 0  // 啟用
            },
            {
                account_id: 16,
                account: 'sandra.young@example.com',
                account_no: 'A016',
                name: 'Sandra Young',
                role_id: 2,  // 獸醫師
                create_date: '2024/08/16',
                status: 0  // 停權
            },
            {
                account_id: 17,
                account: 'paul.king@example.com',
                account_no: 'A017',
                name: 'Paul King',
                role_id: 3,  // 照養組長
                create_date: '2024/08/17',
                status: 0  // 啟用
            },
            {
                account_id: 18,
                account: 'lisa.scott@example.com',
                account_no: 'A018',
                name: 'Lisa Scott',
                role_id: 4,  // 照養員
                create_date: '2024/08/18',
                status: 0  // 啟用
            },
            {
                account_id: 19,
                account: 'james.green@example.com',
                account_no: 'A019',
                name: 'James Green',
                role_id: 1,  // 獸醫主任
                create_date: '2024/08/19',
                status: 0  // 啟用
            },
            {
                account_id: 20,
                account: 'patricia.adams@example.com',
                account_no: 'A020',
                name: 'Patricia Adams',
                role_id: 2,  // 獸醫師
                create_date: '2024/08/20',
                status: 1  // 停權
            }
        ];
        
        
        this.taskList = [
            {
                task_id: 1,
                create_date: '2024-08-31',
                priority: 1,
                type: 0,
                startDate: '2024-09-01',
                endDate: null,
                task_name: '野生動物急救 - 台灣獼猴',
                task_content: '<p>在台中市野生動物急救中心，救援一隻受傷的台灣獼猴，並安排後續的治療和照養。</p>',
                location: 1,
                assignRoleGroup_name: '全院',
                assignAccountList: [1, 3, 4, 6, 7, 8, 10, 11, 13, 14, 17, 18, 19]
            },
            {
                task_id: 2,
                create_date: '2024-08-31',
                priority: 2,
                type: 1,
                startDate: '2024-09-05',
                endDate: '2024-09-06',
                task_name: '獸醫檢查 - 長鬃山羊',
                task_content: '<p>安排獸醫師對一隻受傷的長鬃山羊進行健康檢查和治療。</p>',
                location: 2,
                assignRoleGroup_name: '獸醫組',
                assignAccountList: [2, 5, 9, 12, 16, 20]
            },
            {
                task_id: 3,
                create_date: '2024-08-31',
                priority: 0,
                type: 0,
                startDate: '2024-09-03',
                endDate: null,
                task_name: '救援報告撰寫',
                task_content: '<p>撰寫救援報告，記錄救援過程及動物的恢復情況。</p>',
                location: 0,
                assignRoleGroup_name: '',
                assignAccountList: [8, 13]
            },
            {
                task_id: 4,
                create_date: '2024-08-31',
                priority: 3,
                type: 1,
                startDate: '2024-09-04',
                endDate: '2024-09-05',
                task_name: '緊急救援 - 石虎',
                task_content: '<p>在新竹地區，緊急救援一隻遭受交通事故的石虎。</p>',
                location: 3,
                assignRoleGroup_name: '全院',
                assignAccountList: [1, 3, 4, 6, 7, 8, 10, 11, 13, 14, 17, 18, 19]
            },
            {
                task_id: 5,
                create_date: '2024-08-31',
                priority: 2,
                type: 0,
                startDate: '2024-09-07',
                endDate: null,
                task_name: '照養員培訓 - 動物護理',
                task_content: '<p>為照養員舉辦動物護理相關的培訓課程，提升專業能力。</p>',
                location: 5,
                assignRoleGroup_name: '照養組',
                assignAccountList: [4, 7, 11]
            },
            {
                task_id: 6,
                create_date: '2024-08-31',
                priority: 1,
                type: 1,
                startDate: '2024-09-10',
                endDate: '2024-09-11',
                task_name: '受傷海豚的康復計劃',
                task_content: '<p>制定並實施受傷海豚的康復計劃，確保其順利恢復健康。</p>',
                location: 4,
                assignRoleGroup_name: '獸醫組',
                assignAccountList: [3, 6, 14]
            },
            {
                task_id: 7,
                create_date: '2024-08-31',
                priority: 0,
                type: 0,
                startDate: '2024-09-12',
                endDate: null,
                task_name: '定期健康檢查 - 亞洲象',
                task_content: '<p>為亞洲象進行定期的健康檢查，並記錄其健康狀況。</p>',
                location: 2,
                assignRoleGroup_name: '',
                assignAccountList: [1, 15]
            },
            {
                task_id: 8,
                create_date: '2024-08-31',
                priority: 3,
                type: 1,
                startDate: '2024-09-14',
                endDate: '2024-09-15',
                task_name: '災後救援 - 瀕危物種',
                task_content: '<p>在災後救援行動中，集中救援和保護瀕危物種。</p>',
                location: 1,
                assignRoleGroup_name: '全院',
                assignAccountList: [1, 3, 4, 6, 7, 8, 10, 11, 13, 14, 17, 18, 19]
            },
            {
                task_id: 9,
                create_date: '2024-08-31',
                priority: 0,
                type: 0,
                startDate: '2024-09-16',
                endDate: null,
                task_name: '動物康復觀察',
                task_content: '<p>觀察並記錄受傷動物的康復情況，確保其逐步恢復健康。</p>',
                location: 0,
                assignRoleGroup_name: '',
                assignAccountList: [10, 18]
            },
            {
                task_id: 10,
                create_date: '2024-08-31',
                priority: 2,
                type: 1,
                startDate: '2024-09-18',
                endDate: '2024-09-19',
                task_name: '動物園訪客教育活動',
                task_content: '<p>舉辦教育活動，向訪客宣導野生動物保護的重要性。</p>',
                location: 5,
                assignRoleGroup_name: '照養組',
                assignAccountList: [12, 16, 20]
            }
        ];

        this.taskRecordList = [
            {
                "task_id": 1,
                "account_id": 1,
                "account_name": "John Doe",
                "date": "2024-09-01",
                "completion_time": "2024-09-01 08:30",
                "completed": true
            },
            {
                "task_id": 1,
                "account_id": 3,
                "account_name": "Robert Brown",
                "date": "2024-09-01",
                "completion_time": "2024-09-01 09:15",
                "completed": true
            },
            {
                "task_id": 2,
                "account_id": 2,
                "account_name": "Jane Smith",
                "date": "2024-09-05",
                "completion_time": "2024-09-05 10:00",
                "completed": true
            },
            {
                "task_id": 2,
                "account_id": 5,
                "account_name": "David Lee",
                "date": "2024-09-05",
                "completion_time": "2024-09-05 11:45",
                "completed": true
            },
            {
                "task_id": 2,
                "account_id": 9,
                "account_name": "Kevin Moore",
                "date": "2024-09-06",
                "completion_time": null,
                "completed": false
            },
            {
                "task_id": 3,
                "account_id": 8,
                "account_name": "Susan Martin",
                "date": "2024-09-03",
                "completion_time": "2024-09-03 13:30",
                "completed": true
            },
            {
                "task_id": 3,
                "account_id": 13,
                "account_name": "Charles Lewis",
                "date": "2024-09-03",
                "completion_time": "2024-09-03 16:00",
                "completed": true
            },
            {
                "task_id": 4,
                "account_id": 1,
                "account_name": "John Doe",
                "date": "2024-09-04",
                "completion_time": "2024-09-04 09:45",
                "completed": true
            },
            {
                "task_id": 4,
                "account_id": 3,
                "account_name": "Robert Brown",
                "date": "2024-09-04",
                "completion_time": "2024-09-04 10:30",
                "completed": true
            },
            {
                "task_id": 4,
                "account_id": 4,
                "account_name": "Lucy Wang",
                "date": "2024-09-05",
                "completion_time": null,
                "completed": false
            },
            {
                "task_id": 5,
                "account_id": 4,
                "account_name": "Lucy Wang",
                "date": "2024-09-07",
                "completion_time": "2024-09-07 08:00",
                "completed": true
            },
            {
                "task_id": 5,
                "account_id": 7,
                "account_name": "Michael Jones",
                "date": "2024-09-07",
                "completion_time": "2024-09-07 09:00",
                "completed": true
            },
            {
                "task_id": 5,
                "account_id": 11,
                "account_name": "Jack Wilson",
                "date": "2024-09-07",
                "completion_time": null,
                "completed": false
            },
            {
                "task_id": 6,
                "account_id": 3,
                "account_name": "Robert Brown",
                "date": "2024-09-10",
                "completion_time": "2024-09-10 12:15",
                "completed": true
            },
            {
                "task_id": 6,
                "account_id": 6,
                "account_name": "Emily Taylor",
                "date": "2024-09-11",
                "completion_time": null,
                "completed": false
            },
            {
                "task_id": 7,
                "account_id": 1,
                "account_name": "John Doe",
                "date": "2024-09-12",
                "completion_time": "2024-09-12 08:15",
                "completed": true
            },
            {
                "task_id": 7,
                "account_id": 15,
                "account_name": "George Robinson",
                "date": "2024-09-12",
                "completion_time": "2024-09-12 09:30",
                "completed": true
            },
            {
                "task_id": 8,
                "account_id": 3,
                "account_name": "Robert Brown",
                "date": "2024-09-14",
                "completion_time": "2024-09-14 10:30",
                "completed": true
            },
            {
                "task_id": 8,
                "account_id": 6,
                "account_name": "Emily Taylor",
                "date": "2024-09-15",
                "completion_time": "2024-09-15 11:15",
                "completed": true
            },
            {
                "task_id": 9,
                "account_id": 10,
                "account_name": "Anna Hall",
                "date": "2024-09-16",
                "completion_time": "2024-09-16 13:45",
                "completed": true
            },
            {
                "task_id": 9,
                "account_id": 18,
                "account_name": "Lisa Scott",
                "date": "2024-09-16",
                "completion_time": "2024-09-16 14:30",
                "completed": true
            },
            {
                "task_id": 10,
                "account_id": 12,
                "account_name": "Linda Clark",
                "date": "2024-09-18",
                "completion_time": "2024-09-18 15:00",
                "completed": true
            },
            {
                "task_id": 10,
                "account_id": 16,
                "account_name": "Sandra Young",
                "date": "2024-09-19",
                "completion_time": null,
                "completed": false
            }
        ]
        
        this.consumableItemTypes = [
            { id: 1, item_type_name: '繃帶', erp_group_code: 'C001' },
            { id: 2, item_type_name: '注射器', erp_group_code: 'C002' },
            { id: 3, item_type_name: '手套', erp_group_code: 'C003' },
            { id: 4, item_type_name: '紗布', erp_group_code: 'C004' },
            { id: 5, item_type_name: '棉球', erp_group_code: 'C005' }
        ];
        
        this.instrumentItemTypes = [
            { id: 1, item_type_name: '手術刀', erp_group_code: 'I001' },
            { id: 2, item_type_name: '手術剪', erp_group_code: 'I002' },
            { id: 3, item_type_name: '血壓計', erp_group_code: 'I003' },
            { id: 4, item_type_name: '聽診器', erp_group_code: 'I004' },
            { id: 5, item_type_name: '針灸針', erp_group_code: 'I005' }
        ];

        this.dailyNecessitiesItemTypes = [
            { id: 1, item_type_name: '衛生紙', erp_group_code: 'D001' },
            { id: 2, item_type_name: '洗手液', erp_group_code: 'D002' },
            { id: 3, item_type_name: '垃圾袋', erp_group_code: 'D003' },
            { id: 4, item_type_name: '消毒液', erp_group_code: 'D004' },
            { id: 5, item_type_name: '肥皂', erp_group_code: 'D005' }
        ];

        this.usableFoodItemTypes = [
            { id: 1, item_type_name: '狗糧', erp_group_code: 'F001' },
            { id: 2, item_type_name: '貓糧', erp_group_code: 'F002' },
            { id: 3, item_type_name: '罐頭食品', erp_group_code: 'F003' },
            { id: 4, item_type_name: '營養補充品', erp_group_code: 'F004' },
            { id: 5, item_type_name: '乾糧', erp_group_code: 'F005' }
        ];

        this.medicationItemTypes = [
            { id: 1, item_type_name: '抗生素', erp_group_code: 'M001' },
            { id: 2, item_type_name: '止痛藥', erp_group_code: 'M002' },
            { id: 3, item_type_name: '疫苗', erp_group_code: 'M003' },
            { id: 4, item_type_name: '血檢試紙', erp_group_code: 'M004' },
            { id: 5, item_type_name: '藥膏', erp_group_code: 'M005' }
        ];
        
        this.itemTypes = [
            this.consumableItemTypes,
            this.instrumentItemTypes,
            this.medicationItemTypes,
            this.usableFoodItemTypes,
            this.dailyNecessitiesItemTypes
        ]
        
        
        this.items = [
            // Consumable item types (item_type: 0)
            {
                item_id: 1,
                item_type: 0,
                itemType_id: 1,  // 繃帶
                item_name: '彈性繃帶',
                item_spec: '5cm x 4.5m, 自黏',
                item_no: 'C001001',
                create_date: '2024-08-01',
                status: true,
                item_unit: 4 , // 參考 recipeUnits 的 type 0 -> 'g'
                stock_quantity:20
            },
            {
                item_id: 2,
                item_type: 0,
                itemType_id: 1,  // 繃帶
                item_name: '紗布繃帶',
                item_spec: '10cm x 4.5m, 無菌',
                item_no: 'C001002',
                create_date: '2024-08-03',
                status: true,
                item_unit: 4  // 參考 recipeUnits 的 type 1 -> 'ml'
            },
            {
                item_id: 3,
                item_type: 0,
                itemType_id: 2,  // 注射器
                item_name: '5ml 注射器',
                item_spec: '單次使用, 5ml',
                item_no: 'C002003',
                create_date: '2024-08-05',
                status: true,
                item_unit: 5  // 參考 recipeUnits 的 type 2 -> 'cc'
            },
            {
                item_id: 4,
                item_type: 0,
                itemType_id: 2,  // 注射器
                item_name: '10ml 注射器',
                item_spec: '單次使用, 10ml',
                item_no: 'C002004',
                create_date: '2024-08-07',
                status: true,
                item_unit: 5  // 參考 recipeUnits 的 type 0 -> 'g'
            },
            {
                item_id: 5,
                item_type: 0,
                itemType_id: 3,  // 手套
                item_name: '乳膠手套, 中號',
                item_spec: '100只裝, 中號',
                item_no: 'C003005',
                create_date: '2024-08-09',
                status: true,
                item_unit: 6  // 參考 recipeUnits 的 type 4 -> '隻'
            },
            {
                item_id: 6,
                item_type: 0,
                itemType_id: 3,  // 手套
                item_name: '乳膠手套, 大號',
                item_spec: '100只裝, 大號',
                item_no: 'C003006',
                create_date: '2024-08-11',
                status: true,
                item_unit: 6  // 參考 recipeUnits 的 type 4 -> '隻'
            },
            {
                item_id: 7,
                item_type: 0,
                itemType_id: 4,  // 紗布
                item_name: '無菌紗布, 10cm x 10cm',
                item_spec: '100片/包, 無菌',
                item_no: 'C004007',
                create_date: '2024-08-13',
                status: true,
                item_unit: 4  // 參考 recipeUnits 的 type 0 -> 'g'
            },
            {
                item_id: 8,
                item_type: 0,
                itemType_id: 4,  // 紗布
                item_name: '無菌紗布, 20cm x 20cm',
                item_spec: '50片/包, 無菌',
                item_no: 'C004008',
                create_date: '2024-08-15',
                status: true,
                item_unit: 4  // 參考 recipeUnits 的 type 2 -> 'cc'
            },
            {
                item_id: 9,
                item_type: 0,
                itemType_id: 5,  // 棉球
                item_name: '大號棉球',
                item_spec: '200g, 無菌',
                item_no: 'C005009',
                create_date: '2024-08-17',
                status: true,
                item_unit: 4  // 參考 recipeUnits 的 type 0 -> 'g'
            },
            {
                item_id: 10,
                item_type: 0,
                itemType_id: 5,  // 棉球
                item_name: '小號棉球',
                item_spec: '100g, 無菌',
                item_no: 'C005010',
                create_date: '2024-08-19',
                status: true,
                item_unit: 4  // 參考 recipeUnits 的 type 0 -> 'g'
            },
        
            // Instrument item types (item_type: 1)
            {
                item_id: 11,
                item_type: 1,
                itemType_id: 1,  // 手術刀
                item_name: '手術刀 - 10號',
                item_spec: '鋒利, 不鏽鋼',
                item_no: 'I001011',
                create_date: '2024-08-21',
                status: true,
                item_unit: 5  // 參考 recipeUnits 的 type 0 -> 'g'
            },
            {
                item_id: 12,
                item_type: 1,
                itemType_id: 1,  // 手術刀
                item_name: '手術刀 - 11號',
                item_spec: '鋒利, 不鏽鋼',
                item_no: 'I001012',
                create_date: '2024-08-22',
                status: true,
                item_unit: 5  // 參考 recipeUnits 的 type 0 -> 'g'
            },
            {
                item_id: 13,
                item_type: 1,
                itemType_id: 3,  // 血壓計
                item_name: '電子血壓計',
                item_spec: 'LCD顯示, 自動測量',
                item_no: 'I003013',
                create_date: '2024-08-23',
                status: true,
                item_unit: 9  // 參考 recipeUnits 的 type 1 -> 'ml'
            },
            {
                item_id: 14,
                item_type: 1,
                itemType_id: 3,  // 血壓計
                item_name: '機械式血壓計',
                item_spec: '針式表盤, 手動測量',
                item_no: 'I003014',
                create_date: '2024-08-24',
                status: true,
                item_unit: 5  // 參考 recipeUnits 的 type 1 -> 'ml'
            },
            {
                item_id: 15,
                item_type: 1,
                itemType_id: 4,  // 聽診器
                item_name: '單管聽診器',
                item_spec: '單聲道, 金屬製',
                item_no: 'I004015',
                create_date: '2024-08-25',
                status: true,
                item_unit: 9  // 參考 recipeUnits 的 type 0 -> 'g'
            },
        
            // Daily Necessities item types (item_type: 4)
            {
                item_id: 16,
                item_type: 4,
                itemType_id: 1,  // 衛生紙
                item_name: '雙層衛生紙',
                item_spec: '200張/卷, 柔軟',
                item_no: 'D001016',
                create_date: '2024-08-25',
                status: true,
                item_unit: 4  // 參考 recipeUnits 的 type 0 -> 'g'
            },
            {
                item_id: 17,
                item_type: 4,
                itemType_id: 1,  // 衛生紙
                item_name: '三層衛生紙',
                item_spec: '180張/卷, 厚實',
                item_no: 'D001017',
                create_date: '2024-08-26',
                status: true,
                item_unit: 4  // 參考 recipeUnits 的 type 0 -> 'g'
            },
            {
                item_id: 18,
                item_type: 4,
                itemType_id: 4,  // 消毒液
                item_name: '75%酒精消毒液',
                item_spec: '500ml, 抗菌',
                item_no: 'D004018',
                create_date: '2024-08-27',
                status: true,
                item_unit: 10  // 參考 recipeUnits 的 type 1 -> 'ml'
            },
            {
                item_id: 19,
                item_type: 4,
                itemType_id: 4,  // 消毒液
                item_name: '84消毒液',
                item_spec: '1000ml, 廣譜抗菌',
                item_no: 'D004019',
                create_date: '2024-08-28',
                status: true,
                item_unit: 10  // 參考 recipeUnits 的 type 1 -> 'ml'
            },
            {
                item_id: 20,
                item_type: 4,
                itemType_id: 2,  // 洗手液
                item_name: '抗菌洗手液',
                item_spec: '500ml, 溫和配方',
                item_no: 'D002020',
                create_date: '2024-08-29',
                status: true,
                item_unit: 10  // 參考 recipeUnits 的 type 1 -> 'ml'
            },
        
            // Usable Food item types (item_type: 3)
            {
                item_id: 21,
                item_type: 3,
                itemType_id: 1,  // 狗糧
                item_name: '成犬專用狗糧',
                item_spec: '10kg, 雞肉口味',
                item_no: 'F001021',
                create_date: '2024-08-29',
                status: true,
                item_unit: 7  // 參考 recipeUnits 的 type 0 -> 'g'
            },
            {
                item_id: 22,
                item_type: 3,
                itemType_id: 1,  // 狗糧
                item_name: '幼犬專用狗糧',
                item_spec: '8kg, 牛肉口味',
                item_no: 'F001022',
                create_date: '2024-08-30',
                status: true,
                item_unit: 7  // 參考 recipeUnits 的 type 0 -> 'g'
            },
            {
                item_id: 23,
                item_type: 3,
                itemType_id: 4,  // 營養補充品
                item_name: '犬貓專用維生素補充品',
                item_spec: '500g, 多種維生素',
                item_no: 'F004023',
                create_date: '2024-08-31',
                status: true,
                item_unit: 11  // 參考 recipeUnits 的 type 0 -> 'g'
            },
            {
                item_id: 24,
                item_type: 3,
                itemType_id: 4,  // 營養補充品
                item_name: '犬貓專用礦物質補充品',
                item_spec: '500g, 礦物質豐富',
                item_no: 'F004024',
                create_date: '2024-09-01',
                status: true,
                item_unit: 11  // 參考 recipeUnits 的 type 0 -> 'g'
            },
            {
                item_id: 25,
                item_type: 3,
                itemType_id: 2,  // 貓糧
                item_name: '成貓專用貓糧',
                item_spec: '5kg, 魚味',
                item_no: 'F002025',
                create_date: '2024-09-02',
                status: true,
                item_unit: 7  // 參考 recipeUnits 的 type 0 -> 'g'
            },
        
            // Medication item types (item_type: 2)
            {
                item_id: 26,
                item_type: 2,
                itemType_id: 1,  // 抗生素
                item_name: '阿莫西林膠囊',
                item_spec: '500mg, 100粒/瓶',
                item_no: 'M001026',
                create_date: '2024-08-31',
                status: true,
                item_unit: 10,  // 參考 dosageUnit 的 type 0 -> 'g'
                dosage_form: 2,  // 參考 dosage_forms 的 id -> '膠囊'
                controlled_drugs: true,
                base_bw: 500,  // 基礎體重，隨機產生
                concentration: 20  // 濃度，隨機產生
            },
            {
                item_id: 27,
                item_type: 2,
                itemType_id: 1,  // 抗生素
                item_name: '青黴素注射液',
                item_spec: '100mg/ml, 10ml',
                item_no: 'M001027',
                create_date: '2024-09-01',
                status: true,
                item_unit: 5,  // 參考 dosageUnit 的 type 1 -> 'ml'
                dosage_form: 0,  // 參考 dosage_forms 的 id -> '針劑'
                controlled_drugs: false,
                base_bw: 300,  // 基礎體重，隨機產生
                concentration: 30  // 濃度，隨機產生
            },
            {
                item_id: 28,
                item_type: 2,
                itemType_id: 4,  // 血檢試紙
                item_name: '血糖試紙',
                item_spec: '50片/盒',
                item_no: 'M004028',
                create_date: '2024-09-01',
                status: true,
                item_unit: 9,  // 參考 dosageUnit 的 type 2 -> 'cc'
                dosage_form: 1,  // 參考 dosage_forms 的 id -> '粉劑'
                controlled_drugs: false,
                base_bw: 100,  // 基礎體重，隨機產生
                concentration: 10  // 濃度，隨機產生
            },
            {
                item_id: 29,
                item_type: 2,
                itemType_id: 4,  // 血檢試紙
                item_name: '膽固醇試紙',
                item_spec: '30片/盒',
                item_no: 'M004029',
                create_date: '2024-09-02',
                status: true,
                item_unit: 6,  // 參考 dosageUnit 的 type 2 -> 'cc'
                dosage_form: 1,  // 參考 dosage_forms 的 id -> '粉劑'
                controlled_drugs: false,
                base_bw: 200,  // 基礎體重，隨機產生
                concentration: 50  // 濃度，隨機產生
            },
            {
                item_id: 30,
                item_type: 2,
                itemType_id: 3,  // 疫苗
                item_name: '狂犬病疫苗',
                item_spec: '單劑量, 1ml',
                item_no: 'M003030',
                create_date: '2024-09-03',
                status: true,
                item_unit: 5,  // 參考 dosageUnit 的 type 1 -> 'ml'
                dosage_form: 3,  // 參考 dosage_forms 的 id -> '藥水(不含糖漿)'
                controlled_drugs: true,
                base_bw: 400,  // 基礎體重，隨機產生
                concentration: 40  // 濃度，隨機產生
            }
        ];
        
        this.inventoryRecords = [
            {
                movement_date: '2024/05/30',
                movement_reason: '採購入庫2024050400001',
                movement_quantity: 20,
                stock_quantity: 22,
                staff: 'Bill Chen'
            },
            {
                movement_date: '2024/05/29',
                movement_reason: '出庫',
                movement_quantity: -10,
                stock_quantity: 2,
                staff: '林醫師'
            },
            {
                movement_date: '2024/05/27',
                movement_reason: '出庫',
                movement_quantity: -4,
                stock_quantity: 12,
                staff: 'Bill Chen'
            },
            {
                movement_date: '2024/05/24',
                movement_reason: '出庫',
                movement_quantity: -4,
                stock_quantity: 16,
                staff: 'Jerry'
            },
            {
                movement_date: '2024/05/21',
                movement_reason: '採購入庫2024050100001',
                movement_quantity: 20,
                stock_quantity: 25,
                staff: 'Jerry'
            },
            {
                movement_date: '2024/05/18',
                movement_reason: '庫存調整 - 入庫錯誤',
                movement_quantity: -5,
                stock_quantity: 5,
                staff: 'Jerry'
            },
            {
                movement_date: '2024/05/14',
                movement_reason: '出庫',
                movement_quantity: -10,
                stock_quantity: 10,
                staff: 'Jerry'
            },
            {
                movement_date: '2024/05/10',
                movement_reason: '採購入庫2024042700001',
                movement_quantity: 20,
                stock_quantity: 20,
                staff: 'Jerry'
            }
        ];

        this.purchases = [
            {
                purchase_id: 1,
                purchase_no: 'PO202408010001',
                purchase_date: '2024-08-01',
                purchase_account: 2, // 随机选择的 accountList ID
                purchase_inStock_date: null,
                purchase_inStock_account: null,
                purchase_status: 0  // 采购中
            },
            {
                purchase_id: 2,
                purchase_no: 'PO202408020002',
                purchase_date: '2024-08-02',
                purchase_account: 5, // 随机选择的 accountList ID
                purchase_inStock_date: '2024-08-05',
                purchase_inStock_account: 7, // 随机选择的 accountList ID
                purchase_status: 1  // 已入库
            },
            {
                purchase_id: 3,
                purchase_no: 'PO202408030003',
                purchase_date: '2024-08-03',
                purchase_account: 9, // 随机选择的 accountList ID
                purchase_inStock_date: null,
                purchase_inStock_account: null,
                purchase_status: 0  // 采购中
            },
            {
                purchase_id: 4,
                purchase_no: 'PO202408040004',
                purchase_date: '2024-08-04',
                purchase_account: 12, // 随机选择的 accountList ID
                purchase_inStock_date: '2024-08-07',
                purchase_inStock_account: 10, // 随机选择的 accountList ID
                purchase_status: 1  // 已入库
            },
            {
                purchase_id: 5,
                purchase_no: 'PO202408050005',
                purchase_date: '2024-08-05',
                purchase_account: 14, // 随机选择的 accountList ID
                purchase_inStock_date: null,
                purchase_inStock_account: null,
                purchase_status: 0  // 采购中
            },
            {
                purchase_id: 6,
                purchase_no: 'PO202408060006',
                purchase_date: '2024-08-06',
                purchase_account: 3, // 随机选择的 accountList ID
                purchase_inStock_date: null,
                purchase_inStock_account: null,
                purchase_status: 0  // 采购中
            },
            {
                purchase_id: 7,
                purchase_no: 'PO202408070007',
                purchase_date: '2024-08-07',
                purchase_account: 6, // 随机选择的 accountList ID
                purchase_inStock_date: '2024-08-10',
                purchase_inStock_account: 8, // 随机选择的 accountList ID
                purchase_status: 1  // 已入库
            },
            {
                purchase_id: 8,
                purchase_no: 'PO202408080008',
                purchase_date: '2024-08-08',
                purchase_account: 11, // 随机选择的 accountList ID
                purchase_inStock_date: null,
                purchase_inStock_account: null,
                purchase_status: 0  // 采购中
            },
            {
                purchase_id: 9,
                purchase_no: 'PO202408090009',
                purchase_date: '2024-08-09',
                purchase_account: 13, // 随机选择的 accountList ID
                purchase_inStock_date: '2024-08-12',
                purchase_inStock_account: 15, // 随机选择的 accountList ID
                purchase_status: 1  // 已入库
            },
            {
                purchase_id: 10,
                purchase_no: 'PO202408100010',
                purchase_date: '2024-08-10',
                purchase_account: 1, // 随机选择的 accountList ID
                purchase_inStock_date: null,
                purchase_inStock_account: null,
                purchase_status: 0  // 采购中
            }
        ];

        for (let i = 0; i < this.purchases.length; i++) {
            //亂數產生採購清單陣列
            this.purchases[i].items = []
            const lengthValue = (Math.floor(Math.random() * 5) + 1)
            // this.$debug('lengthValue:',lengthValue)
            

            for (let n = 0; n < lengthValue; n++) {
                const randomValue = Math.floor(Math.random() * this.items.length );
                // this.$debug('randomValue:',randomValue)
                //隨機產生採購數量
                const quantity = Math.floor(Math.random() * 24 )+1
                //隨機產生入庫數量
                let inStockQuantity = 0
                if ( this.purchases[i].purchase_status == 1 ){
                    const randomInStockQuantity = (Math.floor(Math.random() * quantity) + 1)
                    if ( randomInStockQuantity%2 == 1 ){
                        inStockQuantity = randomInStockQuantity
                    }else{
                        inStockQuantity = quantity
                    }
                }


                this.purchases[i].items.push({
                    item_id:this.items[randomValue].item_id,
                    quantity:quantity,
                    inStockQuantity:inStockQuantity
                })

                
            }
            
        }

        this.recipeProcessList = [
            {
                processType: { type: 0, name: '泥' },
                recipes: [
                    { type: 0, type_name: '蔬菜', name: '紅蘿蔔', quantity: '1200/g' },
                    { type: 0, type_name: '蔬菜', name: '地瓜葉', quantity: '1400/g' },
                    { type: 1, type_name: '水果', name: '蘋果', quantity: '1100/g' },
                    { type: 1, type_name: '水果', name: '香蕉', quantity: '1300/g' }
                ]
            },
            {
                processType: { type: 1, name: '塊1*1' },
                recipes: [
                    { type: 2, type_name: '根莖', name: '馬鈴薯', quantity: '1000/g' },
                    { type: 2, type_name: '根莖', name: '蓮藕', quantity: '1500/g' },
                    { type: 3, type_name: '肉', name: '豬肉', quantity: '1200/g' },
                    { type: 3, type_name: '肉', name: '牛肉', quantity: '1400/g' }
                ]
            },
            {
                processType: { type: 2, name: '塊2*2' },
                recipes: [
                    { type: 0, type_name: '蔬菜', name: '高麗菜', quantity: '1600/g' },
                    { type: 0, type_name: '蔬菜', name: '菠菜', quantity: '1800/g' },
                    { type: 1, type_name: '水果', name: '芭樂', quantity: '1200/g' },
                    { type: 1, type_name: '水果', name: '鳳梨', quantity: '1300/g' }
                ]
            },
            {
                processType: { type: 8, name: '條2*2*10' },
                recipes: [
                    { type: 5, type_name: '魚', name: '鯛魚', quantity: '1400/g' },
                    { type: 5, type_name: '魚', name: '鮭魚', quantity: '1500/g' },
                    { type: 3, type_name: '肉', name: '雞胸肉', quantity: '1700/g' },
                    { type: 3, type_name: '肉', name: '火雞肉', quantity: '1600/g' }
                ]
            },
            {
                processType: { type: 6, name: '片1*1' },
                recipes: [
                    { type: 0, type_name: '蔬菜', name: '茄子', quantity: '1200/g' },
                    { type: 0, type_name: '蔬菜', name: '苦瓜', quantity: '1400/g' },
                    { type: 1, type_name: '水果', name: '芒果', quantity: '1300/g' },
                    { type: 1, type_name: '水果', name: '葡萄', quantity: '1100/g' }
                ]
            },
            {
                processType: { type: 4, name: '塊5*5' },
                recipes: [
                    { type: 2, type_name: '根莖', name: '紅蘿蔔', quantity: '1500/g' },
                    { type: 2, type_name: '根莖', name: '洋蔥', quantity: '1600/g' },
                    { type: 3, type_name: '肉', name: '羊肉', quantity: '1200/g' },
                    { type: 3, type_name: '肉', name: '鴨肉', quantity: '1400/g' }
                ]
            }
        ];
        
        this.mealData = [
            {
                record_id: 1,
                patient_id: 'W240112001',
                species: '台灣獼猴',
                alias: '老大',
                feature:'尾巴末端剃毛',
                isFasting:true,
                location: '住院室',
                recipe: [
                    {
                        type: 0, // 自行取食
                        type_name: '自行取食',
                        items: [
                            { processType: { type: 1, name: '塊1*1' }, type: 1, type_name: '水果', name: '香蕉', quantity: '100/g' },
                            { processType: { type: 2, name: '塊2*2' }, type: 2, type_name: '根莖', name: '地瓜', quantity: '80/g' }
                        ],
                        meal_count: 4, // 自行取食分4餐
                        remark: '不要給青椒'  // 随机生成的备注
                    },
                    {
                        type: 1, // 餵食
                        type_name: '餵食',
                        items: [
                            { processType: { type: 6, name: '片1*1' }, type: 0, type_name: '蔬菜', name: '紅蘿蔔', quantity: '120/g' }
                        ],
                        meal_count: 2, // 餵食分2餐
                        remark: ''
                    }
                ],
                status: true  // 已分裝
            },
            {
                record_id: 2,
                patient_id: 'W240112002',
                species: '台灣獼猴',
                alias: '小魚',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: '住院室',
                recipe: [
                    {
                        type: 0, // 自行取食
                        type_name: '自行取食',
                        items: [
                            { processType: { type: 1, name: '塊1*1' }, type: 1, type_name: '水果', name: '香蕉', quantity: '100/g' },
                            { processType: { type: 2, name: '塊2*2' }, type: 2, type_name: '根莖', name: '地瓜', quantity: '80/g' }
                        ],
                        meal_count: 4, // 自行取食分4餐
                        remark: '不加鹽'
                    },
                    {
                        type: 2, // 灌食
                        type_name: '灌食',
                        items: [
                            { processType: { type: 8, name: '條2*2*10' }, type: 10, type_name: '營養液', name: '營養液', quantity: '150/ml' }
                        ],
                        meal_count: 1, // 灌食分1餐
                        remark: '慢速灌食'
                    }
                ],
                status: false  // 未分裝
            },
            {
                record_id: 3,
                patient_id: 'W240112003',
                species: '台灣獼猴',
                alias: '大魚',
                feature:'尾巴末端剃毛',
                isFasting:true,
                location: '住院室',
                recipe: [
                    {
                        type: 1, // 餵食
                        type_name: '餵食',
                        items: [
                            { processType: { type: 4, name: '塊5*5' }, type: 0, type_name: '蔬菜', name: '地瓜葉', quantity: '150/g' },
                            { processType: { type: 4, name: '塊5*5' }, type: 9, type_name: '其他', name: '小米', quantity: '50/g' }
                        ],
                        meal_count: 3, // 餵食分3餐
                        remark: ''
                    }
                ],
                status: true  // 已分裝
            },
            {
                record_id: 4,
                patient_id: 'W240112004',
                species: '穿山甲',
                alias: '小Q',
                feature:'尾巴末端剃毛',
                isFasting:true,
                location: 'ICU',
                recipe: [
                    {
                        type: 3, // 塞食
                        type_name: '塞食',
                        items: [
                            { processType: { type: 6, name: '片1*1' }, type: 11, type_name: '營養品', name: '紅蟲分開', quantity: '100/g' }
                        ],
                        meal_count: 2, // 塞食分2餐
                        remark: ''
                    }
                ],
                status: false  // 未分裝
            },
            {
                record_id: 5,
                patient_id: 'W240112005',
                species: '台灣獼猴',
                alias: '老大',
                location: 'ICU',
                feature:'尾巴末端剃毛',
                isFasting:false,
                recipe: [
                    {
                        type: 0, // 自行取食
                        type_name: '自行取食',
                        items: [
                            { processType: { type: 1, name: '塊1*1' }, type: 1, type_name: '水果', name: '香蕉', quantity: '100/g' },
                            { processType: { type: 2, name: '塊2*2' }, type: 2, type_name: '根莖', name: '地瓜', quantity: '80/g' }
                        ],
                        meal_count: 4, // 自行取食分4餐
                        remark: '不加糖'
                    }
                ],
                status: true  // 已分裝
            },
            {
                record_id: 6,
                patient_id: 'W240112006',
                species: '台灣獼猴',
                alias: '小魚',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: '住院室',
                recipe: [
                    {
                        type: 1, // 餵食
                        type_name: '餵食',
                        items: [
                            { processType: { type: 4, name: '塊5*5' }, type: 0, type_name: '蔬菜', name: '地瓜葉', quantity: '200/g' },
                            { processType: { type: 4, name: '塊5*5' }, type: 9, type_name: '其他', name: '小米', quantity: '25/g' }
                        ],
                        meal_count: 2, // 餵食分2餐
                        remark: ''
                    }
                ],
                status: true  // 已分裝
            },
            {
                record_id: 7,
                patient_id: 'W240112007',
                species: '台灣獼猴',
                alias: '大魚',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: '外籠',
                recipe: [
                    {
                        type: 2, // 灌食
                        type_name: '灌食',
                        items: [
                            { processType: { type: 10, name: '條5*5*15' }, type: 10, type_name: '營養液', name: '營養液', quantity: '120/ml' }
                        ],
                        meal_count: 1, // 灌食分1餐
                        remark: '速度控制'
                    }
                ],
                status: false  // 未分裝
            },
            {
                record_id: 8,
                patient_id: 'W240112008',
                species: '台灣獼猴',
                alias: '大中',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: '住院室',
                recipe: [
                    {
                        type: 1, // 餵食
                        type_name: '餵食',
                        items: [
                            { processType: { type: 4, name: '塊5*5' }, type: 0, type_name: '蔬菜', name: '菠菜', quantity: '150/g' },
                            { processType: { type: 4, name: '塊5*5' }, type: 9, type_name: '其他', name: '小米', quantity: '50/g' }
                        ],
                        meal_count: 3, // 餵食分3餐
                        remark: ''
                    }
                ],
                status: true  // 已分裝
            },
            {
                record_id: 9,
                patient_id: 'W240112009',
                species: '台灣獼猴',
                alias: '小中',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: 'ICU',
                recipe: [
                    {
                        type: 3, // 塞食
                        type_name: '塞食',
                        items: [
                            { processType: { type: 6, name: '片1*1' }, type: 11, type_name: '營養品', name: '維他命C', quantity: '100/g' }
                        ],
                        meal_count: 2, // 塞食分2餐
                        remark: ''
                    }
                ],
                status: true  // 已分裝
            },
            {
                record_id: 10,
                patient_id: 'W240112010',
                species: '穿山甲',
                alias: '小Q',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: '住院室',
                recipe: [
                    {
                        type: 2, // 灌食
                        type_name: '灌食',
                        items: [
                            { processType: { type: 8, name: '條2*2*10' }, type: 10, type_name: '營養液', name: '蛋白質補充液', quantity: '150/ml' }
                        ],
                        meal_count: 1, // 灌食分1餐
                        remark: '每日三次'
                    }
                ],
                status: false  // 未分裝
            },
            {
                record_id: 11,
                patient_id: 'W240112011',
                species: '台灣獼猴',
                alias: '小白',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: '住院室',
                recipe: [
                    {
                        type: 0, // 自行取食
                        type_name: '自行取食',
                        items: [
                            { processType: { type: 6, name: '片1*1' }, type: 1, type_name: '水果', name: '蘋果', quantity: '150/g' },
                            { processType: { type: 2, name: '塊2*2' }, type: 2, type_name: '根莖', name: '紅蘿蔔', quantity: '100/g' }
                        ],
                        meal_count: 4, // 自行取食分4餐
                        remark: '無糖'
                    }
                ],
                status: true  // 已分裝
            },
            {
                record_id: 12,
                patient_id: 'W240112012',
                species: '台灣獼猴',
                alias: '小黑',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: 'ICU',
                recipe: [
                    {
                        type: 1, // 餵食
                        type_name: '餵食',
                        items: [
                            { processType: { type: 4, name: '塊5*5' }, type: 0, type_name: '蔬菜', name: '西紅柿', quantity: '200/g' },
                            { processType: { type: 4, name: '塊5*5' }, type: 9, type_name: '其他', name: '玉米', quantity: '50/g' }
                        ],
                        meal_count: 2, // 餵食分2餐
                        remark: ''
                    }
                ],
                status: true  // 已分裝
            },
            {
                record_id: 13,
                patient_id: 'W240112013',
                species: '台灣獼猴',
                alias: '小金',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: '住院室',
                recipe: [
                    {
                        type: 3, // 塞食
                        type_name: '塞食',
                        items: [
                            { processType: { type: 6, name: '片1*1' }, type: 11, type_name: '營養品', name: '膠原蛋白粉', quantity: '80/g' }
                        ],
                        meal_count: 1, // 塞食分1餐
                        remark: '注意速度'
                    }
                ],
                status: false  // 未分裝
            },
            {
                record_id: 14,
                patient_id: 'W240112014',
                species: '穿山甲',
                alias: '大Q',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: '住院室',
                recipe: [
                    {
                        type: 0, // 自行取食
                        type_name: '自行取食',
                        items: [
                            { processType: { type: 1, name: '塊1*1' }, type: 1, type_name: '水果', name: '梨子', quantity: '200/g' },
                            { processType: { type: 2, name: '塊2*2' }, type: 2, type_name: '根莖', name: '紅蘿蔔', quantity: '150/g' }
                        ],
                        meal_count: 4, // 自行取食分4餐
                        remark: '去皮'
                    }
                ],
                status: true  // 已分裝
            },
            {
                record_id: 15,
                patient_id: 'W240112015',
                species: '台灣獼猴',
                alias: '小灰',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: '住院室',
                recipe: [
                    {
                        type: 1, // 餵食
                        type_name: '餵食',
                        items: [
                            { processType: { type: 4, name: '塊5*5' }, type: 0, type_name: '蔬菜', name: '地瓜葉', quantity: '200/g' },
                            { processType: { type: 4, name: '塊5*5' }, type: 9, type_name: '其他', name: '紅豆', quantity: '50/g' }
                        ],
                        meal_count: 2, // 餵食分2餐
                        remark: ''
                    }
                ],
                status: true  // 已分裝
            },
            {
                record_id: 16,
                patient_id: 'W240112016',
                species: '台灣獼猴',
                alias: '大灰',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: '住院室',
                recipe: [
                    {
                        type: 3, // 塞食
                        type_name: '塞食',
                        items: [
                            { processType: { type: 6, name: '片1*1' }, type: 11, type_name: '營養品', name: '鈣片', quantity: '80/g' }
                        ],
                        meal_count: 2, // 塞食分2餐
                        remark: '隨餐服用'
                    }
                ],
                status: false  // 未分裝
            },
            {
                record_id: 17,
                patient_id: 'W240112017',
                species: '穿山甲',
                alias: '中Q',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: '外籠',
                recipe: [
                    {
                        type: 2, // 灌食
                        type_name: '灌食',
                        items: [
                            { processType: { type: 8, name: '條2*2*10' }, type: 10, type_name: '營養液', name: '魚油', quantity: '120/ml' }
                        ],
                        meal_count: 1, // 灌食分1餐
                        remark: '控制速度'
                    }
                ],
                status: false  // 未分裝
            },
            {
                record_id: 18,
                patient_id: 'W240112018',
                species: '台灣獼猴',
                alias: '小藍',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: '住院室',
                recipe: [
                    {
                        type: 0, // 自行取食
                        type_name: '自行取食',
                        items: [
                            { processType: { type: 1, name: '塊1*1' }, type: 1, type_name: '水果', name: '芒果', quantity: '200/g' },
                            { processType: { type: 2, name: '塊2*2' }, type: 2, type_name: '根莖', name: '胡蘿蔔', quantity: '150/g' }
                        ],
                        meal_count: 4, // 自行取食分4餐
                        remark: '注意甜度'
                    }
                ],
                status: true  // 已分裝
            },
            {
                record_id: 19,
                patient_id: 'W240112019',
                species: '台灣獼猴',
                alias: '大藍',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: '住院室',
                recipe: [
                    {
                        type: 1, // 餵食
                        type_name: '餵食',
                        items: [
                            { processType: { type: 4, name: '塊5*5' }, type: 0, type_name: '蔬菜', name: '西紅柿', quantity: '200/g' },
                            { processType: { type: 4, name: '塊5*5' }, type: 9, type_name: '其他', name: '大米', quantity: '50/g' }
                        ],
                        meal_count: 2, // 餵食分2餐
                        remark: ''
                    }
                ],
                status: true  // 已分裝
            },
            {
                record_id: 20,
                patient_id: 'W240112020',
                species: '穿山甲',
                alias: '小花',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: '住院室',
                recipe: [
                    {
                        type: 3, // 塞食
                        type_name: '塞食',
                        items: [
                            { processType: { type: 6, name: '片1*1' }, type: 11, type_name: '營養品', name: '葡萄糖粉', quantity: '100/g' }
                        ],
                        meal_count: 1, // 塞食分1餐
                        remark: '不含糖'
                    }
                ],
                status: false  // 未分裝
            }
        ];

        this.packMedicineData = [
            {
                record_id: 1,
                patient_id: 'W240112001',
                species: '台灣獼猴',
                alias: '老大',
                feature:'尾巴末端剃毛',
                isPack:false,
                location: '哺乳室',
                router:'口服',
                dosage_form:'粉劑',
                recipe: [
                    { type: 12, type_name: '藥劑', name: '止痛藥', quantity: '50/ml' },
                    { type: 12, type_name: '藥劑', name: '胃藥', quantity: '30/ml' },
                ],
                frequency:'BID',
                total_day:3,
                pack_note:'糖水3:1:1',
                feeding_times: [
                    { time: '08:00', status: 1 },
                    { time: '12:00', status: 1 },
                    { time: '16:00', status: -1 },
                    { time: '20:00', status: 0 }
                ]
            },{
                record_id: 2,
                patient_id: 'W240112001',
                species: '台灣獼猴',
                alias: '老大',
                feature:'尾巴末端剃毛',
                isPack:true,
                location: '哺乳室',
                router:'口服',
                dosage_form:'粉劑',
                recipe: [
                    { type: 12, type_name: '藥劑', name: '止痛藥', quantity: '50/ml' },
                    { type: 12, type_name: '藥劑', name: '胃藥', quantity: '30/ml' },
                ],
                frequency:'BID',
                total_day:3,
                pack_note:'糖水3:1:1',
                feeding_times: [
                    { time: '08:00', status: 0 },
                    { time: '12:00', status: 0 },
                    { time: '16:00', status: 0 },
                    { time: '20:00', status: 0 }
                ]
            }
        ]

        this.feedingData = [
            {
                record_id: 1,
                patient_id: 'W240112001',
                species: '台灣獼猴',
                alias: '老大',
                feature:'尾巴末端剃毛',
                isFasting:true,
                location: '哺乳室',
                recipe: [
                    { type: 13, type_name: '奶粉', name: '營養強化奶粉', quantity: '50/ml' },
                    { type: 13, type_name: '奶粉', name: '成長配方奶粉', quantity: '30/ml' },
                    { type: 14, type_name: '水', name: '水', quantity: '80/ml' }
                ],
                remark: '營養強化奶粉:成長配方奶粉:水 = 50:30:80',
                feeding_times: [
                    { time: '08:00', status: true },
                    { time: '12:00', status: true },
                    { time: '16:00', status: true },
                    { time: '20:00', status: false }
                ]
            },
            {
                record_id: 2,
                patient_id: 'W240112002',
                species: '台灣獼猴',
                alias: '小魚',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: '哺乳室',
                recipe: [
                    { type: 13, type_name: '奶粉', name: '高蛋白配方奶粉', quantity: '100/ml' },
                    { type: 13, type_name: '奶粉', name: '免疫增強奶粉', quantity: '50/ml' },
                    { type: 14, type_name: '水', name: '水', quantity: '150/ml' }
                ],
                remark: '高蛋白配方奶粉:免疫增強奶粉:水 = 100:50:150',
                feeding_times: [
                    { time: '08:00', status: true },
                    { time: '12:00', status: true },
                    { time: '16:00', status: true },
                    { time: '20:00', status: true }
                ]
            },
            {
                record_id: 3,
                patient_id: 'W240112003',
                species: '台灣獼猴',
                alias: '小魚',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: 'ICU',
                recipe: [
                    { type: 13, type_name: '奶粉', name: '免疫增強奶粉', quantity: '150/ml' },
                    { type: 14, type_name: '水', name: '水', quantity: '150/ml' }
                ],
                remark: '免疫增強奶粉:水 = 150:150',
                feeding_times: [
                    { time: '08:00', status: true },
                    { time: '12:00', status: true },
                    { time: '16:00', status: false },
                    { time: '20:00', status: false }
                ]
            },
            {
                record_id: 4,
                patient_id: 'W240112004',
                species: '台灣獼猴',
                alias: '小魚',
                feature:'尾巴末端剃毛',
                isFasting:true,
                location: 'ICU',
                recipe: [
                    { type: 13, type_name: '奶粉', name: '低乳糖奶粉', quantity: '80/ml' },
                    { type: 13, type_name: '奶粉', name: '營養均衡奶粉', quantity: '50/ml' },
                    { type: 14, type_name: '水', name: '水', quantity: '130/ml' }
                ],
                remark: '低乳糖奶粉:營養均衡奶粉:水 = 80:50:130',
                feeding_times: [
                    { time: '08:00', status: true },
                    { time: '12:00', status: true },
                    { time: '16:00', status: true },
                    { time: '20:00', status: false }
                ]
            },
            {
                record_id: 5,
                patient_id: 'W240112005',
                species: '台灣獼猴',
                alias: '老大',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: '哺乳室',
                recipe: [
                    { type: 13, type_name: '奶粉', name: '成長配方奶粉', quantity: '80/ml' },
                    { type: 14, type_name: '水', name: '水', quantity: '80/ml' }
                ],
                remark: '成長配方奶粉:水 = 80:80',
                feeding_times: [
                    { time: '08:00', status: true },
                    { time: '12:00', status: true },
                    { time: '16:00', status: true },
                    { time: '20:00', status: true }
                ]
            },
            {
                record_id: 6,
                patient_id: 'W240112006',
                species: '台灣獼猴',
                alias: '小魚',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: '哺乳室',
                recipe: [
                    { type: 13, type_name: '奶粉', name: '營養均衡奶粉', quantity: '70/ml' },
                    { type: 13, type_name: '奶粉', name: '高鈣強化奶粉', quantity: '80/ml' },
                    { type: 14, type_name: '水', name: '水', quantity: '150/ml' }
                ],
                remark: '營養均衡奶粉:高鈣強化奶粉:水 = 70:80:150',
                feeding_times: [
                    { time: '08:00', status: true },
                    { time: '12:00', status: true },
                    { time: '16:00', status: true },
                    { time: '20:00', status: true }
                ]
            },
            {
                record_id: 7,
                patient_id: 'W240112007',
                species: '台灣獼猴',
                alias: '小魚',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: 'ICU',
                recipe: [
                    { type: 13, type_name: '奶粉', name: '高鈣強化奶粉', quantity: '150/ml' },
                    { type: 14, type_name: '水', name: '水', quantity: '150/ml' }
                ],
                remark: '高鈣強化奶粉:水 = 150:150',
                feeding_times: [
                    { time: '08:00', status: true },
                    { time: '12:00', status: true },
                    { time: '16:00', status: true },
                    { time: '20:00', status: false }
                ]
            },
            {
                record_id: 8,
                patient_id: 'W240112008',
                species: '台灣獼猴',
                alias: '小魚',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: 'ICU',
                recipe: [
                    { type: 13, type_name: '奶粉', name: '低脂配方奶粉', quantity: '80/ml' },
                    { type: 14, type_name: '水', name: '水', quantity: '80/ml' }
                ],
                remark: '低脂配方奶粉:水 = 80:80',
                feeding_times: [
                    { time: '08:00', status: true },
                    { time: '12:00', status: true },
                    { time: '16:00', status: true },
                    { time: '20:00', status: false }
                ]
            },
            {
                record_id: 9,
                patient_id: 'W240112009',
                species: '台灣獼猴',
                alias: '小魚',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: 'ICU',
                recipe: [
                    { type: 13, type_name: '奶粉', name: '免疫增強奶粉', quantity: '150/ml' },
                    { type: 14, type_name: '水', name: '水', quantity: '150/ml' }
                ],
                remark: '免疫增強奶粉:水 = 150:150',
                feeding_times: [
                    { time: '08:00', status: true },
                    { time: '12:00', status: true },
                    { time: '16:00', status: true },
                    { time: '20:00', status: false }
                ]
            },
            {
                record_id: 10,
                patient_id: 'W240112010',
                species: '台灣獼猴',
                alias: '小魚',
                feature:'尾巴末端剃毛',
                isFasting:false,
                location: '哺乳室',
                recipe: [
                    { type: 13, type_name: '奶粉', name: '成長配方奶粉', quantity: '80/ml' },
                    { type: 14, type_name: '水', name: '水', quantity: '80/ml' }
                ],
                remark: '成長配方奶粉:水 = 80:80',
                feeding_times: [
                    { time: '08:00', status: true },
                    { time: '12:00', status: true },
                    { time: '16:00', status: true },
                    { time: '20:00', status: false }
                ]
            }
        ];
        
        this.releaseForms = [
            {
                "form_id": 1,
                "form_name": "鳥類評估表",
                "form_status":0,
                "form_use_count":0,
                "create_time":'2024/05/12',
                "form_species": [
                    {
                        "specie_id": 0,
                        "specie_name": "白頭翁"
                    }
                ],
                "forms": [
                    {
                        "main_item_name": "基本項目",
                        "cols": [
                            {
                                "col_name": "體重",
                                "col_type": 0,
                                "col_unit": "kg",
                                "col_option": []
                            },
                            {
                                "col_name": " 正確印痕",
                                "col_type": 0,
                                "col_unit": "",
                                "col_option": []
                            },
                            {
                                "col_name": "羽毛完整性",
                                "col_type": 0,
                                "col_unit": "",
                                "col_option": []
                            },
                            {
                                "col_name": "獵捕能力",
                                "col_type": 0,
                                "col_unit": "",
                                "col_option": []
                            },
                            {
                                "col_name": "BCS",
                                "col_type": 0,
                                "col_unit": "",
                                "col_option": []
                            },
                            {
                                "col_name": "初級飛羽長好",
                                "col_type": 0,
                                "col_unit": "",
                                "col_option": []
                            },
                            {
                                "col_name": "羽毛防水性",
                                "col_type": 0,
                                "col_unit": "",
                                "col_option": []
                            },
                            {
                                "col_name": "辨識及處理野食",
                                "col_type": 0,
                                "col_unit": "",
                                "col_option": []
                            }
                        ]
                    },
                    {
                        "main_item_name": "飛行評估",
                        "cols": [
                            {
                                "col_name": "對人反應",
                                "col_type": 1,
                                "col_unit": "",
                                "col_option": [
                                    "主動遠離",
                                    "保持距離",
                                    "無反應",
                                    "主動靠近"
                                ]
                            },
                            {
                                "col_name": "對驅趕反應",
                                "col_type": 1,
                                "col_unit": "",
                                "col_option": [
                                    "有",
                                    "無"
                                ]
                            },
                            {
                                "col_name": "飛行平衡",
                                "col_type": 1,
                                "col_unit": "",
                                "col_option": [
                                    "正常",
                                    "傾斜但可抵達目的地",
                                    "傾斜且無法抵達目的地"
                                ]
                            },
                            {
                                "col_name": "飛行速度",
                                "col_type": 1,
                                "col_unit": "",
                                "col_option": [
                                    "正常"
                                ]
                            }
                        ]
                    }
                ]
            }
            
        ]
        
        this.medicineList = [
            {
                id: 1,
                dosage_form: 0, // 針劑
                name: '阿莫西林注射液',
                base_bw: 500, // 基礎體重 (g)
                concentration: 10, // 濃度 (mg/ml)
                dosage_unit: 'ml', // 劑量單位
                dosage_per_unit_bw: 0.2 // 每體重單位劑量 (ml/g)
            },
            {
                id: 2,
                dosage_form: 1, // 粉劑
                name: '頭孢氨苄粉劑',
                base_bw: 300, // 基礎體重 (g)
                concentration: 20, // 濃度 (mg/g)
                dosage_unit: 'g', // 劑量單位
                dosage_per_unit_bw: 0.05 // 每體重單位劑量 (g/g)
            },
            {
                id: 3,
                dosage_form: 2, // 膠囊
                name: '維生素D膠囊',
                base_bw: 250, // 基礎體重 (g)
                concentration: 5000, // 濃度 (IU/顆)
                dosage_unit: '顆', // 劑量單位
                dosage_per_unit_bw: 0.01 // 每體重單位劑量 (顆/g)
            },
            {
                id: 4,
                dosage_form: 3, // 藥水(不含糖漿)
                name: '布洛芬藥水',
                base_bw: 400, // 基礎體重 (g)
                concentration: 100, // 濃度 (mg/ml)
                dosage_unit: 'ml', // 劑量單位
                dosage_per_unit_bw: 0.15 // 每體重單位劑量 (ml/g)
            },
            {
                id: 5,
                dosage_form: 4, // 糖漿
                name: '氯雷他定糖漿',
                base_bw: 350, // 基礎體重 (g)
                concentration: 5, // 濃度 (mg/5ml)
                dosage_unit: 'ml', // 劑量單位
                dosage_per_unit_bw: 0.1 // 每體重單位劑量 (ml/g)
            },
            {
                id: 6,
                dosage_form: 0, // 針劑
                name: '青黴素注射液',
                base_bw: 600, // 基礎體重 (g)
                concentration: 30, // 濃度 (mg/ml)
                dosage_unit: 'ml', // 劑量單位
                dosage_per_unit_bw: 0.2 // 每體重單位劑量 (ml/g)
            },
            {
                id: 7,
                dosage_form: 1, // 粉劑
                name: '甲硝唑粉劑',
                base_bw: 450, // 基礎體重 (g)
                concentration: 15, // 濃度 (mg/g)
                dosage_unit: 'g', // 劑量單位
                dosage_per_unit_bw: 0.03 // 每體重單位劑量 (g/g)
            },
            {
                id: 8,
                dosage_form: 2, // 膠囊
                name: '魚油膠囊',
                base_bw: 200, // 基礎體重 (g)
                concentration: 1000, // 濃度 (mg/顆)
                dosage_unit: '顆', // 劑量單位
                dosage_per_unit_bw: 0.005 // 每體重單位劑量 (顆/g)
            },
            {
                id: 9,
                dosage_form: 3, // 藥水(不含糖漿)
                name: '美沙拉嗪藥水',
                base_bw: 350, // 基礎體重 (g)
                concentration: 40, // 濃度 (mg/ml)
                dosage_unit: 'ml', // 劑量單位
                dosage_per_unit_bw: 0.2 // 每體重單位劑量 (ml/g)
            },
            {
                id: 10,
                dosage_form: 4, // 糖漿
                name: '對乙酰氨基酚糖漿',
                base_bw: 300, // 基礎體重 (g)
                concentration: 120, // 濃度 (mg/5ml)
                dosage_unit: 'ml', // 劑量單位
                dosage_per_unit_bw: 0.1 // 每體重單位劑量 (ml/g)
            },
            {
                id: 11,
                dosage_form: 0, // 針劑
                name: '氟康唑注射液',
                base_bw: 500, // 基礎體重 (g)
                concentration: 2, // 濃度 (mg/ml)
                dosage_unit: 'ml', // 劑量單位
                dosage_per_unit_bw: 0.25 // 每體重單位劑量 (ml/g)
            },
            {
                id: 12,
                dosage_form: 1, // 粉劑
                name: '氯霉素粉劑',
                base_bw: 400, // 基礎體重 (g)
                concentration: 25, // 濃度 (mg/g)
                dosage_unit: 'g', // 劑量單位
                dosage_per_unit_bw: 0.05 // 每體重單位劑量 (g/g)
            },
            {
                id: 13,
                dosage_form: 2, // 膠囊
                name: '葉酸膠囊',
                base_bw: 300, // 基礎體重 (g)
                concentration: 400, // 濃度 (mcg/顆)
                dosage_unit: '顆', // 劑量單位
                dosage_per_unit_bw: 0.01 // 每體重單位劑量 (顆/g)
            },
            {
                id: 14,
                dosage_form: 3, // 藥水(不含糖漿)
                name: '地塞米松藥水',
                base_bw: 250, // 基礎體重 (g)
                concentration: 2, // 濃度 (mg/ml)
                dosage_unit: 'ml', // 劑量單位
                dosage_per_unit_bw: 0.15 // 每體重單位劑量 (ml/g)
            },
            {
                id: 15,
                dosage_form: 4, // 糖漿
                name: '抗組胺糖漿',
                base_bw: 500, // 基礎體重 (g)
                concentration: 5, // 濃度 (mg/5ml)
                dosage_unit: 'ml', // 劑量單位
                dosage_per_unit_bw: 0.1 // 每體重單位劑量 (ml/g)
            }
        ];
        
        this.medicineLog = [
            {
                "id":1,
                "medicine_bw": 200,
                "medicine_doctor": 2,
                "medicine_total_day": 3,
                "create_date":'2024-08-31',
                "prescriptionList": [
                    {
                        "medicine_frequency": 0,
                        "additives": [],
                        "medication_instructions": "",
                        "packing_instructions": "",
                        "isPack": false,
                        "pack_date":null,
                        "use_period": [
                            {
                                "time": "",
                                "isUse": false
                            },
                            {
                                "time": "",
                                "isUse": false
                            }
                        ],
                        "itemList": [
                            {
                                "medicine_route": 0,
                                "medicine_dosage_form": 1,
                                "medicine_item": 2,
                                "medicine_frequency": 0,
                                "medicine_dose": 500,
                                "medicine_copies": 1
                            },
                            {
                                "medicine_route": 0,
                                "medicine_dosage_form": 0,
                                "medicine_item": 6,
                                "medicine_frequency": 0,
                                "medicine_dose": 1333.3,
                                "medicine_copies": 1
                            },
                            {
                                "medicine_route": 0,
                                "medicine_dosage_form": 0,
                                "medicine_item": 11,
                                "medicine_frequency": 0,
                                "medicine_dose": 25000,
                                "medicine_copies": 1
                            }
                        ]
                    },
                ]
            },
            {
                "id":2,
                "medicine_bw": 200,
                "medicine_doctor": 2,
                "medicine_total_day": 3,
                "create_date":'2024-08-26',
                "prescriptionList": [
                    {
                        "medicine_frequency": 1,
                        "additives": ['純水'],
                        "medication_instructions": "加在飼料裡面",
                        "packing_instructions": "混合200cc純水",
                        "isPack": true,
                        "pack_date":'2024-08-27',
                        "use_period": [
                            {
                                "time": "10:00",
                                "isUse": true
                            },
                            {
                                "time": "14:00",
                                "isUse": true
                            },
                            {
                                "time": "18:00",
                                "isUse": false
                            }
                        ],
                        "itemList": [
                            {
                                "medicine_route": 1,
                                "medicine_dosage_form": 1,
                                "medicine_item": 12,
                                "medicine_frequency": 1,
                                "medicine_dose": 400,
                                "medicine_copies": 9
                            }
                        ]
                    }
                ]
            }
        ]

        this.testRecodes = [
            {
                id: 1,
                test_main_type: 0, //內外部檢驗
                test_sub_type: 0, //檢驗類型
                testDeviceID: 3,//檢驗設備
                specimen_type: null, //檢體類型
                inspectionUnits: null, //送檢單位
                createTime: '2024/04/11',
                submitTime: null, //送檢時間
                booking_submitTime: null, //預約送檢時間
                updateTime: '2024/04/11',//檢驗時間 & 報告回傳時間
            },
            {
                id: 2,
                test_main_type: 0, //內外部檢驗
                test_sub_type: 1, //檢驗類型
                testDeviceID: 0,//檢驗設備
                specimen_type: null, //檢體類型
                inspectionUnits: null, //送檢單位
                createTime: '2024/04/10',
                submitTime: null, //送檢時間
                booking_submitTime: null, //預約送檢時間
                updateTime: null,//檢驗時間 & 報告回傳時間
            },{
                id: 3,
                test_main_type: 0, //內外部檢驗
                test_sub_type: 2, //檢驗類型
                testDeviceID: 2,//檢驗設備
                specimen_type: null, //檢體類型
                inspectionUnits: null, //送檢單位
                createTime: '2024/04/09',
                submitTime: null, //送檢時間
                booking_submitTime: null, //預約送檢時間
                updateTime: '2024/04/09',//檢驗時間 & 報告回傳時間
            },
            // {
            //     id: 4,
            //     test_main_type: 0, //內外部檢驗
            //     test_sub_type: 3, //檢驗類型
            //     testDeviceID: null,//檢驗設備
            //     specimen_type: null, //檢體類型
            //     inspectionUnits: null, //送檢單位
            //     createTime: '2024/04/08',
            //     submitTime: null, //送檢時間
            //     booking_submitTime: null, //預約送檢時間
            //     updateTime: null,//檢驗時間 & 報告回傳時間
            // },
            {
                id: 5,
                test_main_type: 0, //內外部檢驗
                test_sub_type: 4, //檢驗類型
                testDeviceID: null,//檢驗設備
                specimen_type: null, //檢體類型
                inspectionUnits: null, //送檢單位
                createTime: '2024/04/07',
                submitTime: null, //送檢時間
                booking_submitTime: null, //預約送檢時間
                updateTime: '2024/04/11',//檢驗時間 & 報告回傳時間
            },{
                id: 6,
                test_main_type: 0, //內外部檢驗
                test_sub_type: 5, //檢驗類型
                testDeviceID: null,//檢驗設備
                specimen_type: null, //檢體類型
                inspectionUnits: null, //送檢單位
                createTime: '2024/04/06',
                submitTime: null, //送檢時間
                booking_submitTime: null, //預約送檢時間
                updateTime: null,//檢驗時間 & 報告回傳時間
            },{
                id: 7,
                test_main_type: 0, //內外部檢驗
                test_sub_type: 6, //檢驗類型
                testDeviceID: null,//檢驗設備
                specimen_type: null, //檢體類型
                inspectionUnits: null, //送檢單位
                createTime: '2024/04/05',
                submitTime: null, //送檢時間
                booking_submitTime: null, //預約送檢時間
                updateTime: '2024/04/05',//檢驗時間 & 報告回傳時間
            },{
                id: 8,
                test_main_type: 0, //內外部檢驗
                test_sub_type: 7, //檢驗類型
                testDeviceID: null,//檢驗設備
                specimen_type: null, //檢體類型
                inspectionUnits: null, //送檢單位
                createTime: '2024/04/04',
                submitTime: null, //送檢時間
                booking_submitTime: null, //預約送檢時間
                updateTime: null,//檢驗時間 & 報告回傳時間
            },{
                id: 9,
                test_main_type: 0, //內外部檢驗
                test_sub_type: 8, //檢驗類型
                testDeviceID: null,//檢驗設備
                specimen_type: null, //檢體類型
                inspectionUnits: null, //送檢單位
                createTime: '2024/04/03',
                submitTime: null, //送檢時間
                booking_submitTime: null, //預約送檢時間
                updateTime: '2024/04/03',//檢驗時間 & 報告回傳時間
            },{
                id: 10,
                test_main_type: 1, //內外部檢驗
                test_sub_type: 0, //檢驗類型
                testDeviceID: null,//檢驗設備
                specimen_type: 1, //檢體類型
                inspectionUnits: 1, //送檢單位
                createTime: '2024/04/03',
                submitTime: null, //送檢時間
                booking_submitTime: null, //預約送檢時間
                updateTime: null,//檢驗時間 & 報告回傳時間
            },{
                id: 11,
                test_main_type: 1, //內外部檢驗
                test_sub_type: 1, //檢驗類型
                testDeviceID: null,//檢驗設備
                specimen_type: 2, //檢體類型
                inspectionUnits: 2, //送檢單位
                createTime: '2024/04/03',
                submitTime: null, //送檢時間
                booking_submitTime: '2024/04/12', //預約送檢時間
                updateTime: null,//檢驗時間 & 報告回傳時間
            },{
                id: 12,
                test_main_type: 1, //內外部檢驗
                test_sub_type: 2, //檢驗類型
                testDeviceID: null,//檢驗設備
                specimen_type: 3, //檢體類型
                inspectionUnits: 3, //送檢單位
                createTime: '2024/04/03',
                submitTime: '2024/04/12', //送檢時間
                booking_submitTime: '2024/04/12', //預約送檢時間
                updateTime: null,//檢驗時間 & 報告回傳時間
            },{
                id: 13,
                test_main_type: 1, //內外部檢驗
                test_sub_type: 3, //檢驗類型
                testDeviceID: null,//檢驗設備
                specimen_type: 4, //檢體類型
                inspectionUnits: 4, //送檢單位
                createTime: '2024/04/03',
                submitTime: '2024/04/12', //送檢時間
                booking_submitTime: '2024/04/12', //預約送檢時間
                updateTime: null,//檢驗時間 & 報告回傳時間
            },{
                id: 14,
                test_main_type: 1, //內外部檢驗
                test_sub_type: 4, //檢驗類型
                testDeviceID: null,//檢驗設備
                specimen_type: 5, //檢體類型
                inspectionUnits: 5, //送檢單位
                createTime: '2024/04/03',
                submitTime: '2024/04/12', //送檢時間
                booking_submitTime: '2024/04/12', //預約送檢時間
                updateTime: '2024/04/12',//檢驗時間 & 報告回傳時間
            },{
                id: 15,
                test_main_type: 1, //內外部檢驗
                test_sub_type: 5, //檢驗類型
                testDeviceID: null,//檢驗設備
                specimen_type: 6, //檢體類型
                inspectionUnits: 5, //送檢單位
                createTime: '2024/04/03',
                submitTime: '2024/04/12', //送檢時間
                booking_submitTime: '2024/04/12', //預約送檢時間
                updateTime: '2024/04/12',//檢驗時間 & 報告回傳時間
            },{
                id: 16,
                test_main_type: 1, //內外部檢驗
                test_sub_type: 6, //檢驗類型
                testDeviceID: null,//檢驗設備
                specimen_type: 7, //檢體類型
                inspectionUnits: 5, //送檢單位
                createTime: '2024/04/03',
                submitTime: '2024/04/12', //送檢時間
                booking_submitTime: '2024/04/12', //預約送檢時間
                updateTime: '2024/04/12',//檢驗時間 & 報告回傳時間
            },{
                id: 17,
                test_main_type: 1, //內外部檢驗
                test_sub_type: 7, //檢驗類型
                testDeviceID: null,//檢驗設備
                specimen_type: 7, //檢體類型
                inspectionUnits: 5, //送檢單位
                createTime: '2024/04/03',
                submitTime: '2024/04/12', //送檢時間
                booking_submitTime: '2024/04/12', //預約送檢時間
                updateTime: '2024/04/12',//檢驗時間 & 報告回傳時間
            },{
                id: 18,
                test_main_type: 1, //內外部檢驗
                test_sub_type: 8, //檢驗類型
                testDeviceID: null,//檢驗設備
                specimen_type: 7, //檢體類型
                inspectionUnits: 5, //送檢單位
                createTime: '2024/04/03',
                submitTime: '2024/04/12', //送檢時間
                booking_submitTime: '2024/04/12', //預約送檢時間
                updateTime: '2024/04/12',//檢驗時間 & 報告回傳時間
            },
            
        ]


        this.eatTimeStatus = [
            {time:'08:00',isCheck:true},
            {time:'10:00',isCheck:false},
            {time:'12:00',isCheck:false},
            {time:'14:00',isCheck:false},
            {time:'16:00',isCheck:false},
        ]
        this.eatRecode = [
            {
                eatTime:'08:00',
                recipeType:0,
                recipeTypeName:'一般食譜',
                eatType:0,
                eatTypeName:'自行取食',
                recipes:[
                    {
                        type:0,
                        process:{
                            type:0,
                            name:'泥'
                        },
                        recipe_name:'地瓜葉',
                        recipe_value:120,
                        recipe_unit:'g',
                    },{
                        type:1,
                        process:{
                            type:1,
                            name:'塊2*2'
                        },
                        recipe_name:'地瓜',
                        recipe_value:180,
                        recipe_unit:'g',
                    },{
                        type:2,
                        process:{
                            type:0,
                            name:'泥'
                        },
                        recipe_name:'香蕉',
                        recipe_value:100,
                        recipe_unit:'g',
                    }
                ],
                note:'加糖水',
                formData:{
                    total:300,
                    eat:250,
                    last:50,
                    unit:0
                }
            },{
                eatTime:'10:00',
                recipeType:1,
                recipeTypeName:'哺乳食譜',
                eatType:1,
                eatTypeName:'餵食',
                recipes:[
                    {
                        type:13,
                        process:null,
                        recipe_name:'A奶粉',
                        recipe_value:80,
                        recipe_unit:'cc',
                    },{
                        type:13,
                        process:null,
                        recipe_name:'B奶粉',
                        recipe_value:160,
                        recipe_unit:'cc',
                    },{
                        type:13,
                        process:null,
                        recipe_name:'C奶粉',
                        recipe_value:160,
                        recipe_unit:'cc',
                    },{
                        type:14,
                        process:null,
                        recipe_name:'水',
                        recipe_value:450,
                        recipe_unit:'cc',
                    }
                ],
                note:'配方奶粉製作原料與比例 1：2：2 (單位cc)',
                formData:{
                    total:600,
                    eat:0,
                    last:0,
                    unit:1
                }
            },{
                eatTime:'12:00',
                recipeType:0,
                recipeTypeName:'一般食譜',
                eatType:1,
                eatTypeName:'灌食',
                recipes:[
                    {
                        type:0,
                        process:{
                            type:0,
                            name:'泥'
                        },
                        recipe_name:'地瓜葉',
                        recipe_value:120,
                        recipe_unit:'g',
                    },{
                        type:1,
                        process:{
                            type:1,
                            name:'塊2*2'
                        },
                        recipe_name:'地瓜',
                        recipe_value:180,
                        recipe_unit:'g',
                    },{
                        type:2,
                        process:{
                            type:0,
                            name:'泥'
                        },
                        recipe_name:'香蕉',
                        recipe_value:100,
                        recipe_unit:'g',
                    }
                ],
                note:'加糖水',
                formData:{
                    total:300,
                    eat:0,
                    last:0,
                    unit:0
                }
            },{
                eatTime:'14:00',
                recipeType:1,
                recipeTypeName:'哺乳食譜',
                eatType:1,
                eatTypeName:'餵食',
                recipes:[
                    {
                        type:13,
                        process:null,
                        recipe_name:'A奶粉',
                        recipe_value:80,
                        recipe_unit:'cc',
                    },{
                        type:13,
                        process:null,
                        recipe_name:'B奶粉',
                        recipe_value:160,
                        recipe_unit:'cc',
                    },{
                        type:13,
                        process:null,
                        recipe_name:'C奶粉',
                        recipe_value:160,
                        recipe_unit:'cc',
                    },{
                        type:14,
                        process:null,
                        recipe_name:'水',
                        recipe_value:450,
                        recipe_unit:'cc',
                    }
                ],
                note:'配方奶粉製作原料與比例 1：2：2 (單位cc)',
                formData:{
                    total:600,
                    eat:0,
                    last:0,
                    unit:1
                }
            },{
                eatTime:'16:00',
                recipeType:0,
                recipeTypeName:'一般食譜',
                eatType:0,
                eatTypeName:'自行取食',
                recipes:[
                    {
                        type:0,
                        process:{
                            type:0,
                            name:'泥'
                        },
                        recipe_name:'地瓜葉',
                        recipe_value:120,
                        recipe_unit:'g',
                    },{
                        type:1,
                        process:{
                            type:1,
                            name:'塊2*2'
                        },
                        recipe_name:'地瓜',
                        recipe_value:180,
                        recipe_unit:'g',
                    },{
                        type:2,
                        process:{
                            type:0,
                            name:'泥'
                        },
                        recipe_name:'香蕉',
                        recipe_value:100,
                        recipe_unit:'g',
                    }
                ],
                note:'加糖水',
                formData:{
                    total:300,
                    eat:0,
                    last:0,
                    unit:0
                }
            }
        ]

        this.anestheticDrugs = [
            {
                drug: '異氟烷',
                use: '誘導',
                dosage_exp: '5%', // 预期剂量
                volume_exp: '2ml', // 预期容量
                route: '吸入',
                dosage_actual: '4.8%', // 实际剂量
                volume_actual: '1.8ml', // 实际容量
                time: '2024/08/30 10:15:30' // 时间
            },
            {
                drug: '丙泊酚',
                use: '維持',
                dosage_exp: '6mg/kg', // 预期剂量
                volume_exp: '10ml', // 预期容量
                route: '靜脈',
                dosage_actual: '5.9mg/kg', // 实际剂量
                volume_actual: '9.5ml', // 实际容量
                time: '2024/08/30 10:45:00' // 时间
            },
            {
                drug: '阿片',
                use: '術後鎮痛',
                dosage_exp: '0.1mg/kg', // 预期剂量
                volume_exp: '0.5ml', // 预期容量
                route: '皮下',
                dosage_actual: '0.09mg/kg', // 实际剂量
                volume_actual: '0.45ml', // 实际容量
                time: '2024/08/30 11:30:45' // 时间
            },
            {
                drug: '依托咪酯',
                use: '誘導',
                dosage_exp: '0.3mg/kg', // 预期剂量
                volume_exp: '5ml', // 预期容量
                route: '靜脈',
                dosage_actual: '0.28mg/kg', // 实际剂量
                volume_actual: '4.8ml', // 实际容量
                time: '2024/08/30 09:45:15' // 时间
            },
            {
                drug: '芬太尼',
                use: '維持',
                dosage_exp: '2μg/kg', // 预期剂量
                volume_exp: '1ml', // 预期容量
                route: '靜脈',
                dosage_actual: '1.9μg/kg', // 实际剂量
                volume_actual: '0.9ml', // 实际容量
                time: '2024/08/30 10:55:20' // 时间
            }
        ];

        this.emergencyDrugs = [
            {
                time: '2024/08/30 11:05:25',
                emergency: '腎上腺素',
                dosage: '0.01mg/kg', // 劑量
                volume: '1ml', // 容量
                route: '靜脈' // 給藥途徑
            },
            {
                time: '2024/08/30 11:15:40',
                emergency: '阿托品',
                dosage: '0.02mg/kg', // 劑量
                volume: '2ml', // 容量
                route: '皮下' // 給藥途徑
            },
            {
                time: '2024/08/30 11:30:10',
                emergency: '地塞米松',
                dosage: '0.1mg/kg', // 劑量
                volume: '3ml', // 容量
                route: '靜脈' // 給藥途徑
            },
            {
                time: '2024/08/30 11:45:55',
                emergency: '可樂定',
                dosage: '0.005mg/kg', // 劑量
                volume: '0.5ml', // 容量
                route: '靜脈' // 給藥途徑
            },
            {
                time: '2024/08/30 12:00:20',
                emergency: '腎上腺素',
                dosage: '0.01mg/kg', // 劑量
                volume: '1ml', // 容量
                route: '靜脈' // 給藥途徑
            }
        ];

        this.otherDrugs = [
            {
                time: '2024/08/30 11:20:30',
                other_drug: '氟馬西尼',
                dosage: '0.3mg/kg', // 劑量
                volume: '1.5ml', // 容量
                route: '靜脈' // 給藥途徑
            },
            {
                time: '2024/08/30 11:35:10',
                other_drug: '咪達唑侖',
                dosage: '0.1mg/kg', // 劑量
                volume: '2ml', // 容量
                route: '肌肉' // 給藥途徑
            },
            {
                time: '2024/08/30 11:50:45',
                other_drug: '地西泮',
                dosage: '0.2mg/kg', // 劑量
                volume: '3ml', // 容量
                route: '靜脈' // 給藥途徑
            },
            {
                time: '2024/08/30 12:05:00',
                other_drug: '異丙酚',
                dosage: '1.5mg/kg', // 劑量
                volume: '10ml', // 容量
                route: '靜脈' // 給藥途徑
            },
            {
                time: '2024/08/30 12:20:15',
                other_drug: '布比卡因',
                dosage: '0.5mg/kg', // 劑量
                volume: '5ml', // 容量
                route: '硬膜外' // 給藥途徑
            }
        ];
        
        this.surgicalMedications = [
            {
                drug_name: '芬太尼',
                dosage_form: '注射液', // 劑型
                route: '靜脈注射', // 途徑
                dosage: '50μg/kg', // 劑量
                frequency: '每15分鐘重複一次' // 使用頻率
            },
            {
                drug_name: '咪達唑侖',
                dosage_form: '注射液', // 劑型
                route: '肌肉注射', // 途徑
                dosage: '0.1mg/kg', // 劑量
                frequency: '手術開始前使用一次' // 使用頻率
            },
            {
                drug_name: '異丙酚',
                dosage_form: '注射液', // 劑型
                route: '靜脈注射', // 途徑
                dosage: '2mg/kg', // 劑量
                frequency: '根據麻醉深度隨時調整' // 使用頻率
            },
            {
                drug_name: '利多卡因',
                dosage_form: '藥膏', // 劑型
                route: '局部塗抹', // 途徑
                dosage: '5%', // 劑量
                frequency: '每30分鐘塗抹一次' // 使用頻率
            },
            {
                drug_name: '右美托咪定',
                dosage_form: '注射液', // 劑型
                route: '靜脈注射', // 途徑
                dosage: '1μg/kg', // 劑量
                frequency: '手術過程中持續滴注' // 使用頻率
            }
        ];
        
        
        
        this.surgicalSupplies = [
            {
                name: '手術手套',
                specification: '中號，無菌', // 規格
                quantity: 50 // 數量
            },
            {
                name: '手術巾',
                specification: '180x150 cm，無菌', // 規格
                quantity: 20 // 數量
            },
            {
                name: '縫合線',
                specification: '4-0，可吸收', // 規格
                quantity: 100 // 數量
            },
            {
                name: '手術刀片',
                specification: '10號，無菌', // 規格
                quantity: 30 // 數量
            },
            {
                name: '紗布墊',
                specification: '10x10 cm，無菌', // 規格
                quantity: 200 // 數量
            }
        ];
        
    }

    getAccountsByStatus = (status)=> {
        let array = []
        for (let index = 0; index < this.accountList.length; index++) {
            const account = this.accountList[index];
            if ( account.status == status ){
                array.push(account)
            } 
        }
        return array
    }

    setItemStockQuantity(){

        for (let index = 0; index < this.items.length; index++) {
            this.items[index].stock_quantity =Math.floor(Math.random() * 101); //亂書隨機生成0~100的數據
            
        }

    }

    getAccount(account_id,col){
        const account = this.accountList.find(item=>item.account_id == account_id)
        return account ? account[col] : null
    }
    


    
}
export default SampleData